import React from "react"
import { Button, Popover, OverlayTrigger } from "react-bootstrap"

import { isLTPM } from "../../../../components/shared_components_registration"
import { withFontSizeConfig } from "../../../config/FontSizeConfigProvider"

// Where we set distinctions for LTPM/LL versions of the component
const registration = {
  title: (intl) =>
    isLTPM
      ? intl.formatMessage({ id: "graphing.edit.font.size", defaultMessage: "Edit Graph Font Size" })
      : "Edit Graph Font Size",
  keyLabel: (intl) =>
    isLTPM ? intl.formatMessage({ id: "graphing.key.label", defaultMessage: "Key Label" }) : "Key Label",
  axisTitleLabel: (intl) =>
    isLTPM ? intl.formatMessage({ id: "graphing.axis.title", defaultMessage: "Axis Title" }) : "Axis Title",
  axisLabel: (intl) =>
    isLTPM ? intl.formatMessage({ id: "graphing.axis.label", defaultMessage: "Axis Label" }) : "Axis Label",
  resetFontSize: (intl) =>
    isLTPM ? intl.formatMessage({ id: "general.reset", defaultMessage: "Reset" }) : "Reset",
}

const FontEditPopover = ({
  labelFontSize,
  axisTitleFontSize,
  tickFontSize,
  updateLabelFontSize,
  updateAxisTitleFontSize,
  updateTickFontSize,
  resetFontSize,
  intl,
}) => {
  const fontEditPopoverStyle = {
    popoverContentDivRow: { margin: "10px" },
    popoverContentDivCol: { marginTop: "5px" },
    PopoverContentInput: { marginLeft: "5px", width: "50px" },
  }

  const FontSizeInput = ({ reg_id, val, updateVal, first = false }) => {
    return (
      <div style={first ? {} : fontEditPopoverStyle.popoverContentDivCol}>
        <label>{registration[reg_id](intl)}</label>:
        <input
          style={fontEditPopoverStyle.PopoverContentInput}
          type="number"
          min="1"
          step="1"
          value={val}
          placeholder={val}
          onWheel={(e) => e.target.blur()}
          onChange={(e) => updateVal(!e.target.value || e.target.value <= 0 ? 1 : e.target.value)}
        />
      </div>
    )
  }

  const overlay = (
    <Popover id="fontEdit" title={registration["title"](intl)}>
      <Popover.Header as="h3">{registration["title"](intl)}</Popover.Header>
      <Popover.Body>
        <div style={fontEditPopoverStyle.popoverContentDivRow}>
          <FontSizeInput
            reg_id={"axisTitleLabel"}
            val={axisTitleFontSize}
            updateVal={updateAxisTitleFontSize}
            first
          />
          <FontSizeInput reg_id={"axisLabel"} val={tickFontSize} updateVal={updateTickFontSize} />
          <FontSizeInput reg_id={"keyLabel"} val={labelFontSize} updateVal={updateLabelFontSize} />
          <div style={fontEditPopoverStyle.popoverContentDivCol}>
            <Button
              title={registration["resetFontSize"](intl)}
              variant={"outline-primary"}
              size="sm"
              onClick={resetFontSize}
            >
              {registration["resetFontSize"](intl)}
            </Button>
          </div>
        </div>
      </Popover.Body>
    </Popover>
  )

  return (
    <OverlayTrigger trigger={"click"} placement="left" rootClose overlay={overlay}>
      <Button title={registration["title"](intl)} variant={"outline-primary"}>
        <span className="fa fa-solid fa-area-chart" />
        <span className="fa fa-solid fa-font" />
      </Button>
    </OverlayTrigger>
  )
}

export default withFontSizeConfig(FontEditPopover)
